<template>
  <b-card-actions action-collapse title="Schedule">
    <div>
       <div
            class="btn-delete-all text-right"
             @click="saveSchedule()">
          <b-button variant="gradient-primary" class="btn-icon btn-delete-all">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </div>
      <div>
        <b-form>
          <!-- ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain" 
          -->
          <b-row
            v-for="(item, index) in items"
            :id="item.id"
            :key="item.id"
            ref="row"
          >
            <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="Start date"
                label-for="startDate"
              >
                <b-form-input
                  id="startDate"
                  type="date"
                  v-model="item.startDate"
                />
              </b-form-group>
            </b-col>

            <b-col b-col cols="12" lg="3" md="3" sm="4" >
              <b-form-group
                label="End date"
                label-for="endDate"
              >
                <b-form-input
                  id="endDate"
                  type="date"
                  v-model="item.endDate"
                />
              </b-form-group>
            </b-col>
      
            <b-col b-col cols="12" lg="6" md="6" sm="6" >
              <b-row v-for="(port, i) in item.stops"
                :id="port.id"
                :key="i"
                >
                <b-col b-col cols="12" lg="4" md="4" sm="6" >
                    <b-form-group
                      label="Departure port"
                      label-for="departurePort"
                    >
                      <b-form-select
                        :options="Portoptions"
                        id="departurePort"
                        v-model="port.departurePort"
                        />
                    </b-form-group>
                </b-col>

                <b-col b-col cols="12" lg="4" md="4" sm="6" >
                    <b-form-group
                      label="Destination port"
                      label-for="arrivalPort"
                    >
                      <b-form-select
                        v-model="port.arrivalPort"
                        :options="Portoptions"
                        id="arrivalPort"
                        />
                    </b-form-group>
                </b-col>

                <b-col lg="1" md="1" cols="12" class="mb-50">
                    <b-button
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-success"
                      class="mt-0 mt-md-2"
                      @click="repeateAgainPorts(index)"
                    >
                      <feather-icon icon="PlusIcon"/>
                    </b-button>
                </b-col>

                <!-- Remove Button -->
                <b-col 
                  v-if="index > 0 || i > 0"
                  lg="1"
                  md="1"
                >
                  <b-button v-if="i > 0"
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2 ml-1"
                    @click="removeItemPort(index,i)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>

                  <b-button v-else
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2 ml-1"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>

                </b-col>

                <b-col cols="12">
                  <hr>
                </b-col>

              </b-row>
            </b-col>
          </b-row >
        </b-form>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
    </div>
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BForm, 
  BFormGroup, 
  BFormInput, 
  BRow, 
  BCol, 
  BButton,
  BFormSelect,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ToastificationContent,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BCardActions,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [{
        id: 1,
        startDate: '',
        endDate: '',
        stops: [
          {
            id:1,
            departurePort: null,
            arrivalPort: null,
          }
        ]
        
      }],
      nextTodoId: 2,
        Portoptions: [
        { value: null, text: 'Please select an option' },
        { value: 'Tunis', text: 'Port Tunis' },
        { value: 'Allemagne', text: 'Port Allemagne' },
        { value: 'America', text: 'Port America' },
        { value: 'France', text: 'Port France'},
      ],

    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    this.getSchedules()
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    getSchedules(){
        axios
        .get(
          "https://mtl-feeder-nodejs.onrender.com/api/schedules"
        )
        .then((response) => {
          this.items=response.data.data[0].entries
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    saveSchedule(){
      console.log(this.items);
        axios
        .put(
          "https://mtl-feeder-nodejs.onrender.com/api/schedules/62411b4e6a18822db54a23ba",{"entries":this.items}

        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Schedule updated",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during update",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
        startDate: '',
        endDate: '',
        stops: [
          {
            departurePort: null,
            arrivalPort: null,
          },
        ],
      })
      // this.$nextTick(() => {
      //   this.trAddHeight(this.$refs.row[0].offsetHeight)
      // })
    },
    repeateAgainPorts(index) {
      this.items[index].stops.push({
        stops: [
          {
            departurePort: null,
            arrivalPort: null,
          }
        ] 
      })
    },
    removeItemPort(index,i){
       this.items[index].stops.splice(i, 1)
    },
    removeItem(index) {
      this.items.splice(index, 1)
      // this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    // initTrHeight() {
    //   this.trSetHeight(null)
    //   this.$nextTick(() => {
    //     this.trSetHeight(this.$refs.form.scrollHeight)
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
 